import columnTypes from '../columnTypes.js';
import types from '../types.js';

const applicationRoleAccounts = [
  {
    key: 'application-role-accounts',
    name: 'Application Role Accounts',
    [columnTypes.default.key]: [
      {
        source: 'UserName',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'AccountType',
        rename: 'Account Type',
        type: types.text,
      },
      {
        source: 'FullName',
        rename: 'Full Name',
        type: types.text,
      },
      {
        source: 'IsDirectMember',
        rename: 'Is Direct Member',
        type: types.text,
      },
      {
        source: 'breadCrumbPath',
        rename: 'Bread Crumb Path',
        type: types.text,
      },
      {
        source: 'Email',
        rename: 'Email',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'HRStatus',
        rename: 'HR Status',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: 'UserSTSGuid', rename: 'ID' }],
  },
  {
    key: 'iam-app-granular-details',
    name: 'IAM Application Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'AppName',
        rename: 'Application Name',
        type: types.text,
      },
      {
        source: 'AppOwner',
        rename: 'Application Owner',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'HRStatus',
        rename: 'HR Status',
        type: types.text,
      },
      {
        source: 'JobDesc',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'ServerCount',
        rename: 'Server Count',
        type: types.text,
      },
      {
        source: 'functionCount',
        rename: 'Functions',
        type: types.number,
      },
      {
        source: 'rolesCount',
        rename: 'Roles',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [{ source: 'id', rename: 'id' }],
  },
  {
    key: 'iam-role-granular-details',
    name: 'IAM Role Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'Role',
        rename: 'Role',
        type: types.text,
      },
      {
        source: 'IsAdmin',
        rename: 'Is Admin',
        type: types.text,
      },
      {
        source: 'RiskLevel',
        rename: 'Risk Level',
        type: types.text,
      },
      {
        source: 'Application',
        rename: 'Application',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'Owner',
        rename: 'Owner',
        type: types.text,
      },
      {
        source: 'Users',
        rename: 'Users',
        type: types.number,
      },
      {
        source: 'Groups',
        rename: 'Groups',
        type: types.number,
      },
      {
        source: 'Functions',
        rename: 'Functions',
        type: types.number,
      },
      {
        source: 'ServerName',
        rename: 'Server Name',
        type: types.text,
      },
      {
        source: 'DatabaseName',
        rename: 'Database Name',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [
      { source: 'AppId', rename: 'AppId' },
      { source: 'RoleId', rename: 'RoleId' },
      { source: 'OwnerStsGuId', rename: 'OwnerStsGuId' },
    ],
  },
  {
    key: 'iam-user-granular-details',
    name: 'IAM Application Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'SamaccountName',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'AppCount',
        rename: 'Applications',
        type: types.number,
      },
      {
        source: 'RoleCount',
        rename: 'Roles',
        type: types.number,
      },
      {
        source: 'FunctionCount',
        rename: 'Functions',
        type: types.number,
      },
      {
        source: 'AdminRoleCount',
        rename: 'Admins',
        type: types.number,
      },
      {
        source: 'NonStdFunCount',
        rename: 'Non-Standard Functions',
        type: types.number,
      },
      {
        source: 'HRStatus',
        rename: 'HR Status',
        type: types.text,
      },
      {
        source: 'JobDescription',
        rename: 'Job Description',
        type: types.text,
      },
      {
        source: 'ServerCount',
        rename: 'Servers',
        type: types.number,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'FirstName',
        rename: 'First Name',
        type: types.text,
      },
      {
        source: 'LastName',
        rename: 'Last Name',
        type: types.text,
      },
      {
        source: 'FullName',
        rename: 'Full Name',
        type: types.text,
      },
      {
        source: 'SupervisorName',
        rename: 'Supervisor Name',
        type: types.text,
      },
      {
        source: 'EmployeeID',
        rename: 'EmployeeID',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      { source: 'CorporateMappingID', rename: 'CorporateMappingID' },
      { source: 'UserStsguid', rename: 'UserStsguid' },
    ],
  },
  {
    key: 'iam-granular-details',
    name: 'IAM Granular Details',
    [columnTypes.default.key]: [
      {
        source: 'Application',
        rename: 'Application',
        type: types.text,
      },
      {
        source: 'Roles',
        rename: 'Roles',
        type: types.number,
      },
      {
        source: 'Functions',
        rename: 'Functions',
        type: types.number,
      },
      {
        source: 'Users',
        rename: 'Users',
        type: types.number,
      },
      {
        source: 'Groups',
        rename: 'Groups',
        type: types.number,
      },
      {
        source: 'Owner',
        rename: 'Owner',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'DepartmentName',
        rename: 'Department Name',
        type: types.text,
      },
      {
        source: 'RiskRating',
        rename: 'Risk Rating',
        type: types.number,
      },
      {
        source: 'ExUserRoles',
        rename: 'Excessive User Roles',
        type: types.number,
      },
      {
        source: 'AdminRoles',
        rename: 'Admin Roles',
        type: types.number,
      },
      {
        source: 'AdminRoleUsers',
        rename: 'Admin Role Users',
        type: types.number,
      },
      {
        source: 'DirectPermFuncUsers',
        rename: 'Direct Permissioned Function Users',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [
      { source: 'AppId', rename: 'AppId' },
      { source: 'OwnerSTSGuid', rename: 'OwnerSTSGuid' },
      { source: 'CorporateMappingID', rename: 'CorporateMappingID' },
    ],
  },
];

export default [...applicationRoleAccounts];
